import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Form, Button, Table, Alert, Spinner, Modal } from "react-bootstrap";

const CashHandoverReport = () => {
  const [handovers, setHandovers] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedHandover, setSelectedHandover] = useState(null);
  const [dateFilter, setDateFilter] = useState("");
  const [employeeFilter, setEmployeeFilter] = useState("");

  // Fetch all cash handovers
  const fetchHandovers = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/cashhandovers/");
      setHandovers(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب تسليمات النقد.");
    } finally {
      setLoading(false);
    }
  };

  // Filter handovers based on date and employee name
  const filteredHandovers = handovers.filter((handover) => {
    const matchesDate = dateFilter 
      ? handover.transaction_date.includes(dateFilter) 
      : true;
    
    const matchesEmployee = employeeFilter 
      ? handover.employee.toLowerCase().includes(employeeFilter.toLowerCase()) 
      : true;
    
    return matchesDate && matchesEmployee;
  });

  // Calculate total handover amount
  const totalHandoverAmount = filteredHandovers.reduce(
    (total, handover) => total + parseFloat(handover.amount),
    0
  ).toFixed(2);

  // Open details modal
  const viewHandoverDetails = (handover) => {
    setSelectedHandover(handover);
    setShowDetails(true);
  };

  useEffect(() => {
    fetchHandovers();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير تسليمات النقد</h1>

      {/* Filters */}
      <div style={{ display: "flex", marginBottom: "20px", gap: "10px" }}>
        <Form.Control
          type="date"
          placeholder="ترتيب حسب التاريخ "
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          style={{ maxWidth: "250px" }}
        />
        <Form.Control
          type="text"
          placeholder="ترتيب حسب اسم الموظف"
          value={employeeFilter}
          onChange={(e) => setEmployeeFilter(e.target.value)}
          style={{ maxWidth: "250px" }}
        />
        <Button 
          variant="outline-secondary" 
          onClick={() => {
            setDateFilter("");
            setEmployeeFilter("");
          }}
          style={{ border: "1px solid darkgreen", color: "darkgreen" }}
        >
          مسح الترتيب
        </Button>
      </div>

      {/* Summary Card */}
      <div style={{ 
        backgroundColor: "white", 
        padding: "15px", 
        marginBottom: "20px", 
        borderRadius: "5px",
        border: "1px solid darkgreen"
      }}>
        <h4 style={{ color: "darkgreen" }}>الملخص</h4>
        <p style={{ fontSize: "18px" }}>
          <strong>إجمالي تسليمات النقد:</strong> ${totalHandoverAmount}
        </p>
        <p>
          <strong>عدد العمليات:</strong> {filteredHandovers.length}
        </p>
      </div>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Handovers Table */
        <Table hover responsive>
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>#</th>
              <th>اسم الموظف</th>
              <th>المبلغ ($)</th>
              <th>التاريخ</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {filteredHandovers.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">لم يتم العثور على تسليمات نقد</td>
              </tr>
            ) : (
              filteredHandovers.map((handover, index) => (
                <tr key={handover.id}>
                  <td>{index + 1}</td>
                  <td>{handover.employee}</td>
                  <td>${parseFloat(handover.amount).toFixed(2)}</td>
                  <td>{handover.transaction_date}</td>
                  <td>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => viewHandoverDetails(handover)}
                      style={{ border: "1px solid darkgreen", color: "darkgreen" }}
                    >
                      عرض التفاصيل
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}

      {/* Details Modal */}
      <Modal show={showDetails} onHide={() => setShowDetails(false)}>
        <Modal.Header closeButton style={{ backgroundColor: "darkgreen", color: "white" }}>
          <Modal.Title>تفاصيل تسليم النقد</Modal.Title>
        </Modal.Header>
        {selectedHandover && (
          <Modal.Body>
            <p><strong>المعرف:</strong> {selectedHandover.id}</p>
            <p><strong>اسم الموظف:</strong> {selectedHandover.employee}</p>
            <p><strong>المبلغ:</strong> ${parseFloat(selectedHandover.amount).toFixed(2)}</p>
            <p><strong>تاريخ العملية:</strong> {selectedHandover.transaction_date}</p>
            <p><strong>ملاحظات:</strong> {selectedHandover.notes || "لا توجد ملاحظات"}</p>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowDetails(false)}
            style={{ backgroundColor: "darkgreen", borderColor: "darkgreen" }}
          >
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CashHandoverReport;